// Create new topic and invite users or send an invite.
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { AccessMode, Tinode } from '../tinode/tinode';

import ContactList from '../widgets/contact-list.jsx';
import NewTopicGroup from '../widgets/new-topic-group.jsx';

import HashNavigation from '../lib/navigation.js';
import { theCard } from '../lib/utils.js';

const messages = defineMessages({
  search_for_contacts: {
    id: "search_for_contacts",
    defaultMessage: "Use search to find contacts",
    description: "Text shown in contacts view when user entered no search query."
  },
  search_no_results: {
    id: "search_no_results",
    defaultMessage: "Search returned no results",
    description: "Text shown in contacts view when query returned no results."
  },
  search_placeholder: {
    id: "search_placeholder",
    defaultMessage: "List like alice@example.com, +17025550003...",
    description: "Placeholder in contacts search field"
  },
});

class NewTopicView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: null
    };

    this.handleSearchContacts = this.handleSearchContacts.bind(this);
    this.handleSearchResultSelected = this.handleSearchResultSelected.bind(this);
    this.handleGroupByID = this.handleGroupByID.bind(this);
    this.handleCreateGroupSuccess = this.handleCreateGroupSuccess.bind(this);
  }

  componentDidMount() {
    this.props.onInitFind();
    this.props.onSearchContacts('')
  }

  handleSearchContacts(query) {
    this.props.onSearchContacts(query);
    this.setState({ searchQuery: Tinode.isNullValue(query) ? null : query });
  }

  handleSearchResultSelected(topicName) {
    if (this.props.tabSelected == 'find') {
      HashNavigation.navigateTo(HashNavigation.removeUrlParam(window.location.hash, 'tab'));
      const topic = this.props.tinode.getTopicByName(topicName, {
        isCreateWhenNotExist: true,
      });
      if (topic) {
        topic.acs = new AccessMode({
          given: 'JRWPASDO',
          want: 'JRWPASDO',
          mode: 'JRWPASDO',
        })
        topic._cachePutSelf()
      }
      this.props.onCreateTopic(topicName);
    }
  }

  handleCreateGroupSuccess(topicId) {
    this.props.onTopicSelected(topicId)
    this.props.onSearchContacts(Tinode.DEL_CHAR)
  }

  handleGroupByID(topicName) {
    HashNavigation.navigateTo(HashNavigation.removeUrlParam(window.location.hash, 'tab'));
    this.props.onCreateTopic(topicName);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const no_contacts_placeholder = formatMessage(this.state.searchQuery ?
      messages.search_no_results : messages.search_for_contacts);
    const search_placeholder = formatMessage(messages.search_placeholder);
    if (this.props.tabSelected === 'grp') {
      return (<NewTopicGroup
        tinode={this.props.tinode}
        onError={this.props.onError}
        contacts={this.props.searchResults}
        myUserId={this.props.myUserId}
        emptyListMessage={no_contacts_placeholder}
        showOnline={false}
        showUnread={false}
        showContextMenu={false}
        handleCreateGroupSuccess={this.handleCreateGroupSuccess}
      />)
    } else {
      return (<div className="flex-column">
        <ContactList
          tinode={this.props.tinode}
          contacts={this.props.searchResults}
          myUserId={this.props.myUserId}
          emptyListMessage={no_contacts_placeholder}
          showOnline={false}
          showUnread={false}
          showContextMenu={false}
          onTopicSelected={this.handleSearchResultSelected} />
      </div>)
    }
  }
};

export default injectIntl(NewTopicView);
